import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface PlayIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const PlayIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: PlayIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.3371 12.4218L7.76844 18.511C7.43558 18.7228 7 18.4837 7 18.0892V5.91085C7 5.5163 7.43558 5.27719 7.76844 5.48902L17.3371 11.5782C17.6459 11.7746 17.6459 12.2254 17.3371 12.4218Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default PlayIcon
